import * as React from "react";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import {
    GetBookOfMindQuotesForDisplay,
    SetPendingBookOfMindDisplayOrder,
} from "../Helpers/BookOfMindQuoteDisplay";
import { SetBookOfMindState } from "../Helpers/BookOfMindHelpers";
import {
    BookOfMindDisplayOrder,
    IBookOfMindState,
} from "../Helpers/IBookOfMindState";

const displayOrderOptions: Array<{
    value: BookOfMindDisplayOrder;
    label: string;
}> = [
    { value: "random", label: "Random" },
    { value: "oldest", label: "Oldest first" },
    { value: "newest", label: "Newest first" },
];

export function DisplayOrderPicker({
    state,
}: {
    state: IBookOfMindState;
}) {
    const displayOrder = state.displayOrder;

    return (
        <span className={pickerClass}>
            <Glyphicon icon={EGlyphicon["align-left"]} />
            <select
                id="bookOfMindDisplayOrder"
                aria-label="Book of Mind quote order"
                value={displayOrder}
                onChange={(event) => {
                    const nextDisplayOrder = event.target
                        .value as BookOfMindDisplayOrder;
                    const quotesForDisplay = GetBookOfMindQuotesForDisplay(
                        state.chronologicalQuotes,
                        nextDisplayOrder,
                        state.searchText
                    );
                    SetPendingBookOfMindDisplayOrder(
                        state,
                        nextDisplayOrder,
                        quotesForDisplay
                    );

                    SetBookOfMindState({
                        displayOrder: nextDisplayOrder,
                        remainingQuotesToDisplay: quotesForDisplay,
                        totalQuotesToDisplay: quotesForDisplay.length,
                        selectedQuote: undefined,
                    });
                }}
                className={selectClass}
            >
                {displayOrderOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        </span>
    );
}

const pickerClass = StyleClass(`bookOfMindDisplayOrderPicker`, {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.35em",
    width: "100%",
    minWidth: 0,
    color: "inherit",
});

const selectClass = StyleClass(`bookOfMindDisplayOrderSelect`, {
    flex: "1 1 auto",
    minWidth: 0,
    width: "100%",
    padding: "2px 0",
    border: 0,
    outline: "none",
    background: "transparent",
    color: "inherit",
    fontFamily: "inherit",
    fontSize: "inherit",
    textAlign: "center",
    cursor: "pointer",
    ":focus": {
        textDecoration: "underline",
    },
});
